import React from 'react';
import { Field } from 'redux-form';
import TextInput from '../common/TextInput';

const ValidatedTextInput = (props) => {
	return (
		<div className={props.className || ""}>
			<Field {...props} component={TextInput} />
		</div>
	);
}

export default ValidatedTextInput



// WEBPACK FOOTER //
// ./src/components/common/ValidatedTextInput.jsx